<template>
  <div class="fixed top-10 right-10 z-[1000] flex flex-col-reverse gap-5">
    <div
      v-for="(toast, key) in toasts"
      v-bind:key
      :class="[
        'flex rounded-lg p-4 shadow-toast toast-animate w-[416px] flex-col gap-4',
        toastClasses[toast.type ?? 'info']
      ]"
    >
      <div class="flex items-start justify-between w-full">
        <div class="flex gap-2 items-center">
          <Icon
            :icon="toastIcons[toast.type ?? 'info']"
            width="20"
            color="white"
            class="cursor-pointer w-5 h-5"
          ></Icon>
          <p class="text-white">{{ toast.message }}</p>
        </div>

        <Icon
          icon="heroicons-solid:x"
          width="20"
          color="white"
          @click="removeToast(toast.id!)"
          class="cursor-pointer w-5 h-5"
        ></Icon>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { useToastStore } from '@/shared/model/toast.store'

const { toasts, removeToast } = useToastStore()

const toastClasses = {
  error: 'bg-danger-40',
  warning: 'bg-[#F17D0F]',
  success: 'bg-[#00A462]',
  info: 'bg-information-50'
}

const toastIcons = {
  error: 'heroicons:exclamation-circle-20-solid',
  warning: 'material-symbols:warning',
  success: 'heroicons:check-circle-20-solid',
  info: 'heroicons:information-circle-20-solid'
}
</script>

<style scoped>
.toast-animate {
  animation: fadeInUp 0.3s;
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translate3d(0, -20%, 0);
  }
  to {
    opacity: 1;
    transform: translateZ(0);
  }
}
</style>
